import React from 'react';
import './popup-overlay-mobile.scss';

function overlayMobile({closePopup, title, popupClass, children}) {
    return (
        <div className={popupClass}>
            <header>
                <a href="#!" className="btn-close" onClick={closePopup}>&times;</a>
                <h2>{title}</h2>
            </header>
            {children}
        </div>
    );
}

export default overlayMobile;


// WEBPACK FOOTER //
// ./src/fPopup/popup_types/overlay-mobile/index.js